export default {
  data () {
    return {
      translate: {
        'system_specification': 'システム仕様',
        'system_function': 'システム機能',
        'usecase': 'ユースケース',
        'communication_design': '通信設計',
        'property': 'プロパティ',
        'attribute': 'アトリビュート',
        'retry_interval': '再送回数',
        'max_retry_count': '再送回数',
        'buffer_oc_a': 'バッファ段数: OC_A',
        'buffer_oc_it': 'バッファ段数: OC_IT',
        'buffer_ic_a': 'バッファ段数: IC_A',
        'buffer_ic_ma': 'バッファ段数: IC_MA',
        'buffer_ic_it': 'バッファ段数: IC_IT',
        'buffer_rc_ma': 'バッファ段数: RC_MA',
        'buffer_adp_it': 'バッファ段数: ADP_IT',
        'err_a': 'フレームエラーレート err_A',
        'err_ma': 'フレームエラーレート err_MA',
        'err_it': 'フレームエラーレート err_IT',
        'simulation_time': 'シミュレーション時間'
      },
      childRelations: {
        'system_specification': 'system_function',
        'system_function': 'usecase',
        'usecase': 'communication_design'
      }
    }
  },
  methods: {
    makeToast (title, message, variant = 'default') {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true
      })
    }
  }
}
